export default "__VITE_ASSET__Deen66E6__"